// /admin/is_user_has_bot_by_user_id

import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://bothelpertest.pp.ua', // Замініть на ваш базовий URL API
  headers: {
    'Content-Type': 'application/json',
  },
});

export default {
  isUserHasBot(userId) {
    return apiClient.get('/admin/is_user_has_bot_by_user_id', {
        params: { user_id: userId },
    });
  }
};
